import './SelectablePiece.less';
import React from 'react';

/**
 * Not implemented yet
 */
export default class SelectablePiece extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return <div className="selectable-piece">

        </div>;
    }
}
